import { Container, Box } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";
import { JSX, ReactElement } from "react";

import bannerBkg from "../assets/bannerBkg.svg";
import { DARK_SCHEME, scrimOver } from "../theme/dark-scheme-css";

const ColoredBanner = ({
  children,
}: {
  children: ReactElement;
}): JSX.Element => (
  <ColoredBannerBox mt={7} pt={4}>
    <Container>{children}</Container>
  </ColoredBannerBox>
);

const ColoredBannerBox = styled(Box)(({ theme }: { theme: Theme }) => {
  const white = theme.palette.common.white;
  return {
    backgroundColor: "transparent",
    color: white,
    backgroundImage: `url(${bannerBkg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "100% 0%",
    height: 168,
    h2: {
      color: white,
    },
    h6: {
      color: white,
    },
    "& .MuiButton-root": {
      color: white,
    },
    [DARK_SCHEME]: {
      backgroundImage: scrimOver(`url(${bannerBkg})`),
    },
  };
}) as unknown as typeof Box;

export default ColoredBanner;
